




















// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'ResetToNewPasswordFormComponent',
  components: {}
})
export default class ResetToNewPasswordFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public preFilledUser: TokenUser = null
  public fwPasswordCode: string = null
  public REQUIRE_PASSWORD2 = true
  public password: string = null
  public password2: string = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public clearFields() {
    this.password = null;
    this.password2 = null;
  }
  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { preFilledUser: TokenUser, fwPasswordCode: string }) {
    // console.log('ResetToNewPasswordFormComponent.onShow()', dynamicProps)
    if (!dynamicProps) return
    if (dynamicProps.preFilledUser) this.preFilledUser = dynamicProps.preFilledUser
    if (dynamicProps.fwPasswordCode) this.fwPasswordCode = dynamicProps.fwPasswordCode
  }

  public async onOK() {
    // tidy up form fields
    if (this.password) this.password = this.password.trim()
    if (this.password2) this.password2 = this.password2.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.password || this.password.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please create a password.')
    } else if (!utils.isValidPassword(this.password)) {
      abort = true
      utils.toast(this, 'Invalid password', 'Your password must be at least 4 characters.')
    }
    if (this.REQUIRE_PASSWORD2) {
      if (!this.password2 || this.password2.length === 0) {
        abort = true
        utils.toast(this, 'Missing field', 'Password is required twice.')
      }
      if (this.password !== this.password2) {
        abort = true
        utils.toast(this, 'Invalid passwords', 'Passwords must match.')
      }
    }

    if (abort) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/changePassword'
      const response: any = await utils.makePostCall(url, { userId: this.preFilledUser.getIdAsString(), fwPasswordCode: this.fwPasswordCode, password: this.password, password2: this.password2 } );
      if (!response || !response.data) throw(new Error('ResetToNewPasswordFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user && response.data.sessionId) {
        // success
        this.$emit('close', true)

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)

        utils.toast(this, "Success", "Password changed and you are now logged in.")

        // go to homepage - wrap in try/catch to avoid NavigationDuplicated error
        try { await this.$router.push({ name: 'home'}) } catch (Error) {}

        // clear out in case they do another
        this.clearFields()
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not set password')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }


}
